import { useState, useEffect, useRef, useLayoutEffect  } from 'react';
import api from '../api/api';
import InventoryForm from './InventoryForm'; // Adjust path accordingly
import './css/OrdersPage.css';
import TopNav from '../components/TopNav';
import { useAuth } from '../context/AuthContext';
import ConfirmModal from '../components/ConfirmModal';
import AlertModal from '../components/AlertModal';
import wsUrl from '../api/wsUrl';

function OrdersPage() {
  const [inventory, setInventory] = useState([]);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [orders, setOrders] = useState([]);
  const [serialNumberError, setSerialNumberError] = useState('');
  const [matchedInventoryItem, setMatchedInventoryItem] = useState(null);
  const [matchedInventoryItems, setMatchedInventoryItems] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [editedServicesMap, setEditedServicesMap] = useState({});
  const [showAddToInventory, setShowAddToInventory] = useState(false);
  const [showInventoryModal, setShowInventoryModal] = useState(false);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [trackingOrderId, setTrackingOrderId] = useState(null);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [trackingNumber_out, setTrackingNumber_out] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [userEntitlements, setUserEntitlements] = useState([]);
  const { user, logout } = useAuth();
  const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000'
  const [fileMap, setFileMap] = useState({});
  const [videoModalUrl, setVideoModalUrl] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewType, setPreviewType] = useState(null); // 'image' or 'video'
  const [newNote, setNewNote] = useState('');
  const [newMessage, setNewMessage] = useState('');
  const messagesEndRef = useRef(null);
  const [messages, setMessages] = useState({}); 
  const messagesContainerRefs = useRef({});
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const [confirmState, setConfirmState] = useState({
    open: false,
    message: '',
    onConfirm: () => {},
  });
  
  const [alertState, setAlertState] = useState({
    open: false,
    message: '',
  });

  const showAlert = (message) => {
    setAlertState({ open: true, message });
  };

  const askConfirm = (message, onConfirm) => {
    setConfirmState({
      open: true,
      message,
        onConfirm: () => {
        onConfirm();
        setConfirmState({ open: false, message: '', onConfirm: () => {} });
      },
    });
  };
  
  const handleSelectInventoryItem = (item) => {
  setForm(prev => ({
    ...prev,
    inventory_id: item.id,
    serial_number: item.serial_number,
    returnbydate: form.returnbydate || null
  }));
  setMatchedInventoryItems([]);
  setSerialNumberError('');

  // ✅ Check if there's an order for this item
  const existingOrder = orders.find(
    order => order.inventory_id === item.id && order.status !== 'Completed'
  );

  if (existingOrder) {
    setSerialNumberError(
  <span>
    This item already has an active order (Order ID:{' '}
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        handleViewOrder(existingOrder.id);
      }}
      style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
    >
      {existingOrder.id}
    </a>
    ).
  </span>
);

  }
};


const handleViewOrder = async (orderId) => {
  const order = orders.find(o => o.id === orderId);
  if (order) {
    try {
      //const res = await api.get(`/orders/${orderId}`);
      setOrders([order]);
      // optionally add it to your orders list
    } catch (err) {
      console.error('Failed to fetch order:', err);
    }
  }
};

  const handleSendMessage = async (id, text) => {
   if (text === '' || text.length === 0 || !text.trim()) return;

  const msgObj = {
    text,
    sender: user?.name || 'You',
    timestamp: new Date().toISOString(),
  };

  // Append to server-stored notes
  const existingNotesRes = await api.get(`/orders/${id}`);
  //console.log('existingNotesRes', existingNotesRes)
  let existingNotes = [];

try {
  const rawNotes = existingNotesRes.data.notes;

  existingNotes = Array.isArray(rawNotes)
    ? rawNotes
    : JSON.parse(rawNotes || '[]');

  if (!Array.isArray(existingNotes)) {
    console.warn('Parsed notes is not an array:', existingNotes);
    existingNotes = [];
  }
} catch (err) {
  console.error('Failed to parse existing notes:', err);
  existingNotes = [];
}


 const updatedNotes = [...existingNotes, msgObj];

// If you're storing notes as a JSON string in PostgreSQL:
await api.put(`/orders/${id}`, { notes: JSON.stringify(updatedNotes) });

  // Update local UI
  setMessages(prev => ({
    ...prev,
    [id]: [...(prev[id] || []), msgObj]
  }));
  // Scroll to bottom after state updates (delay with setTimeout)

  setTimeout(() => {
  const container = messagesContainerRefs.current[id];
  if (container) {
    container.scrollTop = container.scrollHeight;
  }
}, 50);

};

const scrollAllChatsToBottom = () => {
  Object.values(messagesContainerRefs.current).forEach(container => {
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  });
};

  const openPreviewModal = (fileUrl) => {
    const ext = fileUrl.split('.').pop().toLowerCase();
    if (['mp4', 'mpeg'].includes(ext)) {
      setPreviewType('video');
    } else if (['jpg', 'jpeg', 'png'].includes(ext)) {
      setPreviewType('image');
    } else {
      setPreviewType(null);
    }
    setPreviewUrl(fileUrl);
  };

  const [form, setForm] = useState({
      inventory_id: '',
      provider_id: '',
      services_selected: '',
      notes: '', 
      notesprovider: '',
      returnbydate: null,
      returnetadate:  null,
      status: '',
      price: ''
  });

  const loadData = () => {
    api.get('/inventory').then(res => setInventory(res.data));
    api.get('/providers').then(res => {
    setProviders(res.data);
    const defaultProvider = res.data.find(p => p.is_default);
    if (defaultProvider) {
      setForm(form => ({ ...form, provider_id: defaultProvider.id }));
      setSelectedProvider(defaultProvider);
      if (defaultProvider.services_offered) {
        setServices(defaultProvider.services_offered.split(',').map(s => s.trim()));
      }
    }
  });
    
    fetchOrders();
  };

  useEffect(() => {
    document.title = "Services - Services Irene's Wigs.com";
    loadData();
  }, []);

  useEffect(() => {
    if (orders.length > 0) {
      orders.forEach(order => {
        fetch(`${API_BASE}/orders/${order.id}/files`, {
          credentials: 'include'
        })
          .then(res => res.json())
          .then(files => {
            setFileMap(prev => ({ ...prev, [order.id]: files }));
          })
          .catch(err => console.error('Failed to fetch files:', err));
      });
    }
  }, [orders]);


const bulkWorkinProgess = async () => {
  const WorkingQueue = orders.filter(order =>
    selectedOrders.includes(order.id) 
  );

  askConfirm(`Are you sure you want to move ${WorkingQueue.length} order(s) to Work in Progress?`, async () => {
    const date = new Date();
    const newDate = formatDate(date);
    await Promise.all(WorkingQueue.map(order =>
      api.put(`/orders/${order.id}`, { status: 'Work in Progress',  work_started_date: newDate })
    ));
    setSelectedOrders([]);
    fetchOrders();
  });
};
  
const handleShip = (id) => {
  setTrackingOrderId(id);
  setTrackingNumber_out('');
  setShowTrackingModal(true);
};

const submitTrackingNumber = async () => {
  try {
    if (trackingOrderId === 'bulk') {
      // Apply tracking number to all selected orders
      const date = new Date();
      const NewDate = formatDate(date); 
      await Promise.all(
        selectedOrders.map(id =>
          api.put(`/orders/${id}`, {
            status: 'Shipped to NY',
            tracking_number_out: trackingNumber_out,
            tracking_number_out_date: NewDate,
          })
        )
      );
      setSelectedOrders([]);
    } else {
      // Single order shipment
      await api.put(`/orders/${trackingOrderId}`, {
        status: 'Shipped to NY',
        tracking_number_out: trackingNumber_out
      });
    }

    // Reset state and close modal
    setShowTrackingModal(false);
    setTrackingOrderId(null);
    setTrackingNumber_out('');
    fetchOrders();
  } catch (err) {
    console.error('Error updating tracking number:', err);
  }
};


const handleSave = async (id) => {
  const order = orders.find(o => o.id === id);
  if (!order) return;

  const updatedServices =
    editedServicesMap[id] || (order.services_selected ? order.services_selected.split(',').map(s => s.trim()) : []);


  try {
    await api.put(`/orders/${id}`, {
      inventory_id: order.inventory_id,
      provider_id: order.provider_id,
      services_selected: updatedServices.join(', '), // ✅ Use edited services
      notes: order.notes, // ✅ Updated notes
      notesprovider: order.notesprovider,
      returnbydate: order.returnbydate,
      returnetadate: order.returnetadate,
      status: 'Updated',
      price: order.price,
      
    });
    fetchOrders(); // Refresh list
  } catch (err) {
    console.error('Error saving order:', err);
  }
};



  const fetchOrders = async () => {
  try {
    const res = await api.get('/orders');
    setOrders(res.data);
    setAllOrders(res.data); // optional filtering support

    const messagesMap = {};

    res.data.forEach(order => {
      try {
        let parsed = [];

        if (Array.isArray(order.notes)) {
          parsed = order.notes;
        } else if (typeof order.notes === 'string') {
          parsed = JSON.parse(order.notes || '[]');
        }

        if (!Array.isArray(parsed)) {
          console.warn(`Order ${order.id} notes is not an array`, parsed);
          parsed = [];
        }

        messagesMap[order.id] = parsed;
      } catch (e) {
        console.error(`Failed to parse notes for order ${order.id}`, e);
        messagesMap[order.id] = [];
      }
    });

    setMessages(messagesMap);
    setTimeout(() => {
      scrollAllChatsToBottom();
    }, 100);
  } catch (err) {
    console.error('Error fetching orders:', err);
  }
};

function detectCarrier(trackingNumber) {
  if (!trackingNumber) return null;

  const fedexRegex = /^\d{12,15}$/;
  const upsRegex = /^1Z[0-9A-Z]{16}$/i;

  if (upsRegex.test(trackingNumber)) return 'ups';
  if (fedexRegex.test(trackingNumber)) return 'fedex';

  return null; // or 'unknown'
}

function getTrackingLinkAuto(trackingNumber) {
  const carrier = detectCarrier(trackingNumber);
  if (!carrier) return null;

  switch (carrier) {
    case 'fedex':
      return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNumber}`;
    case 'ups':
      return `https://www.ups.com/track?loc=en_US&tracknum=${trackingNumber}`;
    default:
      return null;
  }
}
  const handleProviderChange = (e) => {
    const providerId = e.target.value;
    const provider = providers.find(p => p.id == providerId);
    setForm({ ...form, provider_id: providerId });
    setSelectedProvider(provider);
    if (provider?.services_offered) {
      setServices(provider.services_offered.split(',').map(s => s.trim()));
    } else {
      setServices([]);
    }
    setSelectedServices([]);
  };
  

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this order?')) return;
  
    try {
      await api.delete(`/orders/${id}`);
      fetchOrders(); // refresh the list
    } catch (err) {
      console.error('Error deleting order:', err);
    }
  };

  const toggleService = (service) => {
    setSelectedServices(prev =>
      prev.includes(service) ? prev.filter(s => s !== service) : [...prev, service]
    );
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
    if (!form.inventory_id) {
    setSerialNumberError('Please enter a valid serial number before submitting.');
    return;
  }
  try {
    await api.post('/orders', {
      ...form,
      services_selected: selectedServices.join(', '),
      status: form.status || 'New'
    });

    // Find the default provider again
    const defaultProvider = providers.find(p => p.is_default);

    setForm({
      inventory_id: '',
      provider_id: defaultProvider?.id || '',
      services_selected: '',
      notes: '',
      notesprovider: '',
      returnbydate: null,
      returnetadate: null,
      status: '',
      price: ''
      
    });

    setSelectedProvider(defaultProvider || null);
    setSelectedServices([]);
    setServices(
      defaultProvider?.services_offered
        ? defaultProvider.services_offered.split(',').map(s => s.trim())
        : []
    );

    loadData();
  } catch (err) {
    console.error('Error creating order:', err);
  }
};


const handleComplete = async (id) => {
  try {
    await api.put(`/orders/${id}`, { status: 'Completed' });
    fetchOrders(); // Refresh the list after update
  } catch (err) {
    console.error('Error completing order:', err);
  }
};

  const handleCancel = async (id) => {
  try {
    await api.put(`/orders/${id}`, { status: 'Canceled' });
    fetchOrders(); // Refresh the list after update
  } catch (err) {
    console.error('Error canceling order:', err);
  }
};

const handleSerialNumberChange = (e) => {
  const serialNumber = e.target.value.trim();
  setForm((prev) => ({ ...prev, serial_number: serialNumber }));
  if (serialNumber.length === 0) setOrders(allOrders)
};



const bulkDelete = async () => {
  if (!window.confirm('Are you sure you want to delete selected orders?')) return;
  await Promise.all(selectedOrders.map(id => api.delete(`/orders/${id}`)));
  setSelectedOrders([]);
  fetchOrders();
};

const formatDate = (isoDateStr) => {
  if (!isoDateStr) return '';
  const date = new Date(isoDateStr);
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

const CreateShipOrder = async () => {
  //if (!window.confirm('Are you sure you want to complete selected orders?')) return;
  await Promise.all(selectedOrders.map(id => api.put(`/orders/${id}`, { status: 'Shippment Pending', shipping_group: selectedOrders.join('-') })));
  setSelectedOrders([]);
  fetchOrders();
};

const bulkComplete = async () => {
  if (!window.confirm('Are you sure you want to complete selected orders?')) return;
  await Promise.all(selectedOrders.map(id => api.put(`/orders/${id}`, { status: 'Completed' })));
  setSelectedOrders([]);
  fetchOrders();
};

const bulkCancel = async () => {
  if (!window.confirm('Are you sure you want to cancel selected orders?')) return;
  await Promise.all(selectedOrders.map(id => api.put(`/orders/${id}`, { status: 'Canceled' })));
  setSelectedOrders([]);
  fetchOrders();
};

const CancelShipping  = (e) => {
  //e.preventDefault();
  setSelectedOrders([]);
}

const bulkShip = () => {
  if (selectedOrders.length === 0) return;
  setTrackingOrderId('bulk'); // Use 'bulk' as a flag
  setTrackingNumber_out('');
  setShowTrackingModal(true);
};

const handleReturnDateChange = async (orderId, newDate) => {
  
  const parsedDate = newDate?.trim() === '' ? null : newDate;
  console.log('parsedDate', parsedDate)
  try {
    // Update UI state
    setOrders(prev =>
      prev.map(order =>
        order.id === orderId
          ? { ...order, returnetadate: parsedDate, status: 'Updated' }
          : order
      )
    );

    // Persist change to backend
    await api.put(`/orders/${orderId}`, {
      returnetadate: parsedDate,
      status: 'Updated',
    });
  } catch (err) {
    console.error('Failed to update return date:', err);
  }
};


const handleReturnDateChange2 = async (orderId, newDate) => {
  try {
    //await api.put(`/orders/${orderId}`, { returnByDate: newDate });
    setOrders(prev =>
      prev.map(order =>
        order.id === orderId ? { ...order, returnetadate: newDate } : order
      )
    );

  } catch (error) {
    console.error('Error updating send by date ETA:', error);
  }
};

const handlePriceChange = async (orderId, newPrice) => {
  try {
    setOrders(prev =>
      prev.map(order =>
        order.id === orderId ? { ...order, price: newPrice } : order
      )
    );

  } catch (error) {
    console.error('Error updating price:', error);
  }
};

const findItem = () => {
  const serialNumber = form.serial_number?.trim();

  // Validate input
  if (!serialNumber) {
    setSerialNumberError('Please enter a serial number.');
    setOrders(allOrders); // Reset orders list
    return;
  }

  setSerialNumberError('');
  setOrders(allOrders); // Reset to full list before filtering

  const searchValue = serialNumber.toLowerCase();

  // Find inventory items matching serial number
  const matchedItems = inventory.filter(item =>
    item.serial_number?.toLowerCase().includes(searchValue)
  );

  // Match orders by inventory_id
  const matchingOrders = allOrders.filter(order =>
    matchedItems.some(item => item.id === order.inventory_id)
  );

  // Update orders list in state
  setOrders(matchingOrders);
};

const fetchSingleOrderNotes = async (orderId) => {
  console.log('Updating notes for', orderId)
  try {
    const res = await api.get(`${API_BASE}/orders/${orderId}`);
    const rawNotes = res.data.notes;
    let parsedNotes = [];

    try {
      parsedNotes = Array.isArray(rawNotes)
        ? rawNotes
        : JSON.parse(rawNotes || '[]');
    } catch (e) {
      console.error('Failed to parse notes:', e);
    }

    setMessages((prev) => ({
      ...prev,
      [orderId]: parsedNotes,
    }));

    setTimeout(() => {
      const container = messagesContainerRefs.current[orderId];
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }, 50);
  } catch (err) {
    console.error('Error fetching order notes:', err);
  }
};


//Listen
useEffect(() => {
  const socket = new WebSocket(wsUrl());

  socket.onmessage = (event) => {
  try {
    const msg = JSON.parse(event.data);

    if (msg.type === 'ORDER_UPDATED') {
      const payload = JSON.parse(msg.orderId); // Actually contains { id, changes }
      const realOrderId = payload.id;
      const changes = payload.changes;

      if (!realOrderId) return;

      console.log('🔄 WebSocket update for order:', realOrderId);

      const trackedFields = [
        'notes',
        'price',
        'returnbydate',
        'returnetadate',
        'services_selected',
        'status',
        'tracking_number_in',
        'tracking_number_out',
        'tracking_number_in_date',
        'tracking_number_out_date',
        'appointment_date',
        'completed_date',
        'paid_on'
      ];

      const changedFields = [];

      trackedFields.forEach((field) => {
        const oldVal = changes[field]?.old;
        const newVal = changes[field]?.new;
        const changed = JSON.stringify(oldVal) !== JSON.stringify(newVal);
        if (changed) changedFields.push(field);
      });

      console.log('changedFields', changedFields);

      if (changedFields.includes('notes')) {
        fetchSingleOrderNotes(realOrderId);
      }
    }
  } catch (err) {
    console.error('WebSocket message error:', err);
  }
};


  return () => socket.close();
}, []);


  return (
    <>
    <TopNav />
    <div className="inventory-container">
      
<div className="form-group">
  
  <div className="input-button-group">
    <input
      type="text"
      placeholder="Serial Number"
      value={form.serial_number || ''}
      onChange={handleSerialNumberChange}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
          e.preventDefault(); // Prevent form submission or tabbing away
          findItem();
        }
      }}
      className="input"
    />

    <button type="button" onClick={() => findItem()} className="button small blue">Find</button>
  </div>
  
  
  {matchedInventoryItem && (
    <div className="status-message success">
      Found: {matchedInventoryItem.name} (ID: {matchedInventoryItem.id})
    </div>
  )}
  {serialNumberError && (
    <div className="status-message error">{serialNumberError}</div>
  )}

  {matchedInventoryItems.length > 0 && (
  <div className="status-message success">
    Found: 
    {matchedInventoryItems.map(item => (
      <div
        key={item.id}
        className="match-item"
        onClick={() => handleSelectInventoryItem(item)}
        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', padding: '4px 0' }}
      >
        {item.name}: {item.serial_number}
      </div>
    ))}
    {serialNumberError && (
    <div className="status-message error">{serialNumberError}</div>
  )}
  </div>
)}


</div>
  {showInventoryModal && (
    <div className="modal-overlay">
      <div className="modal-content">
        <button onClick={() => setShowInventoryModal(false)} className="modal-close">×</button>
        <InventoryForm
          serialNumber={form.serial_number}
          onClose={() => setShowInventoryModal(false)}
          onItemAdded={(newItem) => {
            setMatchedInventoryItem(newItem);
            setForm(f => ({ ...f, inventory_id: newItem.id }));
            setShowAddToInventory(false);
            setShowInventoryModal(false);
            loadData();
          }}
        />
      </div>
    </div>
  )}

{showTrackingModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      <button onClick={() => setShowTrackingModal(false)} className="modal-close">×</button>
      <h3>Enter Tracking Number</h3>
      <input
        type="text"
        placeholder="Tracking Number"
        value={trackingNumber_out}
        onChange={(e) => setTrackingNumber_out(e.target.value)}
        className="input"
      />
      <button onClick={submitTrackingNumber} className="button green">Submit</button>
    </div>
  </div>
)}

  <h2 className="section-subheader">Current Queue</h2>
  <div className="form-group">
  <label>Filter by Status:</label>
  <select
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
    className="input"
  >
    <option value="All">All</option>
    <option value="New">New</option>
    <option value="Updated">Updated</option>
    <option value="Work in Progress">Work in Progress</option>
    <option value="Shipped to Factory">Shipped to Factory</option>
    <option value="Shipped to NY">Shipped to NY</option>
  </select>
</div>

  {selectedOrders.length > 0 && (
    <div className="bulk-actions">
      <span>{selectedOrders.length} selected</span>
      <div className="action-buttons">
        <button onClick={bulkWorkinProgess} className="button green">Mark Work in Progress</button>
        <button onClick={bulkShip} className="button blue">Mark Shipped</button>
        <button onClick={CancelShipping} className="button carmine">Cancel</button>
      </div>
    </div>
  )}

  <div className="card-grid">
    
    {orders
    
   .filter(order => {
    const matchesStatus = statusFilter === 'All'
      ? order.status !== 'Completed' && order.status !== 'Canceled'
      : order.status === statusFilter;

    const matchesEntitlement = user?.entitlements?.includes(order.provider_id);

    return matchesStatus && matchesEntitlement;
  
  })
  .map(order => {

      const inventoryItem = inventory.find(i => i.id === order.inventory_id)?.serial_number || '—';
      const provider = providers.find(p => p.id === order.provider_id)?.name || '—';
      const isSelected = selectedOrders.includes(order.id);
      const providerObj = providers.find(p => p.id === order.provider_id);
      const servicesList = providerObj?.services_offered?.split(',').map(s => s.trim()) || [];
      const currentSelected = editedServicesMap[order.id] || (order.services_selected?.split(',').map(s => s.trim()) || []);

      const toggleEditedService = (service) => {
        setEditedServicesMap(prev => {
          const prevServices = prev[order.id] || currentSelected;
          const updated = prevServices.includes(service)
            ? prevServices.filter(s => s !== service)
            : [...prevServices, service];
          return { ...prev, [order.id]: updated };
        });
      };

      return (
        <div key={order.id} className={`card ${order.status.toLowerCase()}`}>
          {['New', 'Updated', 'Canceled'].includes(order.status) && (
            <div className={`status-label ${order.status.toLowerCase()}`}>{order.status}</div>
          )}
          <div className="card-checkbox">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => {
                setSelectedOrders(prev =>
                  isSelected ? prev.filter(id => id !== order.id) : [...prev, order.id]
                );
              }}
            />
          </div>
          <h3 className="card-title">Repair #{order.id}</h3>
          <p><strong>Serial:</strong> {inventoryItem}</p>
           {/*<p><strong>Factory:</strong> {provider}</p>*/}
          <p><strong>Services:</strong> {order.services_selected}</p>
          <p><strong>Status:</strong> {order.status}</p>

          <div className="order-field">
            <p><strong>Send By Date: </strong>{order.returnbydate ? formatDate(order.returnbydate) : ''}</p>
          </div>
          <div className="order-field">
            <strong>Send Back Date ETA: </strong>
              <input type="date" value={order.returnetadate ? order.returnetadate.split('T')[0] : null} onChange={e => handleReturnDateChange(order.id, e.target.value)}  />
          </div>
          <div className="order-field">
            <p><strong>Price: </strong>
              <input type="text" placeholder="Price" value={order.price || ''} onChange={(e) => handlePriceChange(order.id, e.target.value)}  />
              <button onClick={() => handleSave(order.id)} className="button tiny yellow">Update</button>
            </p>
          </div>
          {order.paid_on  && ['admin', 'employee'].includes(user.role) && <p><strong>Paid on: </strong> {formatDate(order.paid_on)}</p> }
          {order.tracking_number_in ? ( <p><strong>Tracking #:</strong> <a href={getTrackingLinkAuto(order.tracking_number_in)} target="_blank" rel="noopener noreferrer">{order.tracking_number_in}</a></p>) : <p>&nbsp;</p> }
          {order.tracking_number_in && order.tracking_number_in_date && <p><strong>Shipped on:</strong> {formatDate(order.tracking_number_in_date)}</p> }
          {order.tracking_number_out ? ( <p><strong>Return Tracking #:</strong> <a href={getTrackingLinkAuto(order.tracking_number_out)} target="_blank" rel="noopener noreferrer">{order.tracking_number_out}</a></p>) : <p>&nbsp;</p> }
          {order.tracking_number_out && order.tracking_number_out_date && <p><strong>Shipped back on:</strong> {formatDate(order.tracking_number_out_date)}</p> }
          {fileMap[order.id]?.length > 0 && (
  <>
  <p><strong>Files:</strong></p>
  <div className="uploaded-files-container">
  {fileMap[order.id]?.map(file => {
  // extract extension
  const urlWithoutQuery = file.url?.split('?')[0];
  const ext = urlWithoutQuery?.split('.').pop()?.toLowerCase() || '';

  // Determine type
  const isImage = ['jpg', 'jpeg', 'png'].includes(ext);
  const isVideo = ['mp4', 'mov', 'mpeg'].includes(ext);
  const isPdf = ext === 'pdf';

  // Assume your backend stores thumbnails under /uploads/thumbnails/ named as baseName.webp or baseName.png
  const baseName = file.fullName.replace(/\.[^/.]+$/, ''); // remove extension
  let thumbUrl = '';

  if (isImage) {
    // image thumbnail .webp from your sharp thumbnails
    thumbUrl = `${API_BASE}/uploads/thumbnails/${baseName}.webp`;
  } else if (isVideo) {
    // video thumbnail .png from your ffmpeg screenshots
    thumbUrl = `${API_BASE}/uploads/thumbnails/${baseName}.png`;
  }

  return (
    <div key={file.url} className="uploaded-file-item">
      {(isImage || isVideo) && file.thumbnailExists ? (
       <div
  className="thumbnail-wrapper"
  onClick={() => openPreviewModal(`${API_BASE}${file.url}`, isImage ? 'image' : ext)}
  style={{ cursor: 'pointer' }}
>
  <img
    src={thumbUrl}
    alt="Thumbnail"
    className="thumbnail"
  />
  {isVideo && (
    <div className="play-button-overlay">▶</div>
  )}
</div>

      ) : (isImage || isVideo) ? (
        <div
          style={{
            width: 100,
            height: 100,
            background: '#eee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          Processing...
        </div>
      ) : null}

      {isPdf && (
        <div
          className="pdf-thumbnail"
          onClick={() => window.open(`${API_BASE}${file.url}`, '_blank', 'noopener,noreferrer')}
          style={{ cursor: 'pointer' }}
        >
          📄
        </div>
      )}


    </div>
  );
})}



</div>
    </>
    )}
  {previewUrl && (
  <div className="video-modal">
    <div className="video-modal-content">
      <button className="video-modal-close" onClick={() => setPreviewUrl(null)}>×</button>
      {previewType === 'video' && (
        <video controls autoPlay style={{ width: '100%', maxHeight: '80vh' }}>
          <source src={`${previewUrl}`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
      {previewType === 'image' && (
        <img src={`${previewUrl}`} alt="Preview" style={{ maxWidth: '100%', maxHeight: '80vh' }} />

      )}
    </div>
  </div>
)}
          <div className="chat-box">
      <div  ref={el => { messagesContainerRefs.current[order.id] = el; }} id={order.id} className="chat-messages" >
        {(messages[order.id] || []).map((msg, index) => (
          <div key={index} style={{ marginBottom: '8px' }}>
            <strong>{msg.sender}</strong>{' '}
            <small>{new Date(msg.timestamp).toLocaleString()}</small>
            <div>{msg.text}</div>
          </div>
        ))}
      </div>
      <textarea rows={4} placeholder="Type a message..." value={newMessage[order.id] || ''} onChange={(e) => {
          setNewMessage(prev => ({ ...prev, [order.id]: e.target.value }));
        }} onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault(); // prevent newline
              handleSendMessage(order.id, newMessage[order.id]);
              setNewMessage(prev => ({ ...prev, [order.id]: '' }));
            }
        }} style={{ width: '99%', resize: 'none', marginBottom: '8px' }}  />
        <div style={{ textAlign: 'right' }}>
          <button className="button small blue send" onClick={() => {
            handleSendMessage(order.id, newMessage[order.id]);
            setNewMessage(prev => ({ ...prev, [order.id]: '' }));
            }} >
            Send
          </button>
        </div>
    </div>
    {/*
          <div className="card-actions">
            
            <button onClick={() => handleSave(order.id)} className="button small yellow">Update</button>
            
            <button onClick={() => handleDelete(order.id)} className="button small red">Delete</button>
            <button onClick={() => handleComplete(order.id)} className="button small green">Complete</button>
            
            <button onClick={() => handleCancel(order.id)} className="button small carmine" >Cancel</button>
            
          </div>
          */}
        </div>
      );
    })}
  </div>
</div>

    {alertState.open && (
      <AlertModal message={alertState.message} onClose={() => setAlertState({ open: false, message: '' })} />
    )}
    {confirmState.open && (
      <ConfirmModal open={confirmState.open} message={confirmState.message} onConfirm={confirmState.onConfirm} onCancel={() => setConfirmState({ open: false, message: '', onConfirm: () => {} })  } />
    )}

    </>
  );
}

export default OrdersPage;
